import { cn } from '@/lib/utils'
import { MapPin, Phone, Store } from 'lucide-react'
import { useOrg } from '@/context/OrgContext'

export default function Footer({ className }: { className?: string }) {
  const { org } = useOrg()

  const nama = org?.nama ?? ''
  const alamat = org?.alamat ?? null
  const noTelp = org?.no_telp ?? null

  if (!nama) return null

  return (
    <footer className={cn('bg-gray-800 text-gray-400 py-6 text-sm', className)}>
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-2 md:grid-cols-3 gap-4 items-start">
        {/* Kiri - Nama Toko */}
        <div className="flex items-start justify-start gap-2">
          <Store size={16} className="text-blue-400 shrink-0" />
          <span className="text-white font-medium">{nama}</span>
        </div>

        {/* Tengah - Alamat */}
        {alamat && (
          <div className="flex flex-col gap-1 md:items-center md:col-span-1">
            <div className="flex items-center gap-2 md:justify-center">
              <MapPin size={16} className="text-blue-400 shrink-0" />
              <span>{alamat}</span>
            </div>
            {noTelp && (
              <div className="flex items-center gap-2 md:hidden">
                <Phone size={16} className="text-blue-400 shrink-0" />
                <span className="text-white">{noTelp}</span>
                <p className="text-xs">(WA only)</p>
              </div>
            )}
          </div>
        )}

        {/* Kanan - Telepon (desktop) */}
        {noTelp && (
          <div className="hidden md:flex items-center justify-end gap-2">
            <Phone size={16} className="text-blue-400 shrink-0" />
            <span className="text-white">{noTelp}</span>
            <span className="text-xs">(WA only)</span>
          </div>
        )}
      </div>
    </footer>
  )
}
